import { FiltersState } from "../types/custom-types";

export const DEFAULT_FILTERS_STATE: FiltersState = {
  searchValue: "",
  selectedOption: null,
  fromDate: null,
  toDate: null,
};

export const JOBTYPE_OPTIONS: { value: string | number; label: string }[] | [] =
  [
    { label: "Contract", value: "CONTRACT" },
    { label: "Permanent Full time", value: "FULL_TIME" },
    { label: "Permanent Part time", value: "PART_TIME" },
    { label: "Walk in", value: "WALKIN" },
    { label: "Social", value: "SOCIAL" },
  ];

export const LANDING_PAGE_OR_DEFAULT_JOBTYPE: string = "ALL";

export const AUTOSEARCH_SUGGESTION_LENGTH: {page: number; limit: number} = {
  page: 1,
  limit: 10
};


export const PASSIVE_JOB = 'OUTREACH_EMAIL'